<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Computer Engineering"
                   :links="[{title:'Home', url:'/'},{title:'News & Events'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="12"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">News & Events</div>
          <TabView>
            <tab-panel header="News">
              <activity-component v-for="news in newsList" :key="news" :activity="news"></activity-component>
            </tab-panel>
            <tab-panel header="Events">
              <activity-component v-for="event in events" :key="event" :activity="event"></activity-component>
            </tab-panel>
          </TabView>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/computer/Sidebar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import ActivityComponent from "@/components/ActivityComponent";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "News_Events",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    TabView, TabPanel,
    ActivityComponent,
    KeyRecruiters
  },

  data() {
    return {
      newsList: [
        {
          name: "एसएनडी अभियांत्रिकीच्या ३२ विद्यार्थ्यांची निवड",
          date: "1 Dec 2019",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/computer/news_event/news/01-12-2019.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "येवल्यात आयटी व नॉन आयटीच्या विद्यार्थ्यांसाठी व्हॅलू ऍड प्रोग्रॅचे आयोजन",
          date: "3 April 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/computer/news_event/news/03-4-21.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "एसएनडी अभियांत्रिकीच्या १० विद्यार्थ्यांची निवड ",
          date: "23 March 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/computer/news_event/news/23-03-21.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "एसएनडी अभियांत्रिकीच्या ७ विद्यार्थ्यांची निवड ",
          date: "03 March 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/computer/news_event/news/03-03-2021.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "एसएनडी अभियांत्रिकी महाविद्यालयामध्ये ओमान येथील इंडस्ट्री एक्सपर्टतर्फे करिअर मार्गदर्शन",
          date: "13 March 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/computer/news_event/news/13-3-21.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "आठवणीत रमले अभियंते ",
          date: "08 March 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/computer/news_event/news/08-03-2021 alumini meet.jpeg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        }
      ],
      events: [
        {
          name: "Tree Plantation",
          date: "",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/computer/social_activities/ac1/1.jpg",
              "thumbnailImageSrc": "",
              "alt": "Description for Image 1",
              "title": "Title 1"
            },
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
